import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const listHeaderTooltip = tooltipMessage => (
  <Tooltip id="data-bar__item-tooltip">{tooltipMessage}</Tooltip>
);

const ListHeader = ({ headers }) => (
  <thead>
    <tr className="tvt-report-list__header">
      {headers.map(h => (
        <th className="tvt-report-list__cell" key={uuid()}>
          {h.label}
          {h.tooltip && (
            <OverlayTrigger
              placement="top"
              overlay={listHeaderTooltip(h.tooltip)}
            >
              <i className="list-header__title-tooltip fa fa-info-circle" />
            </OverlayTrigger>
          )}
        </th>
      ))}
    </tr>
  </thead>
);

ListHeader.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired
};

export default ListHeader;
